import ActionLink from '../../../../Components/Dashboard/ActionLink';
import Card from '../../../../Components/Dashboard/Card';
import { CardEmpty, CardError, CardLoading } from '../../../../Components/Dashboard/CardState';
import API from '../../../../Utils/api';
import useAsync from '../../../../Hooks/useAsync';
import { formatShortDate } from '../../../../Utils/dates/formatDate';
import styles from '../dashboardCards.module.css';

const TITLE = 'Latest test';

const dateText = value => {
    const date = new Date(value);
    return value && !Number.isNaN(date.getTime()) ? `${formatShortDate(date)} ${date.getFullYear()}` : '–';
};
const speed = value => (typeof value === 'number' && Number.isFinite(value) ? `${value} m/s` : '–');

// Shows the stored test record as returned by the API; CSS and MSS are never calculated here.
const LatestTestCard = ({ athleteId, testsPath = '/tests' }) => {
    const { status, data, error, reload } = useAsync(() => API.getLatestTest(athleteId).then(res => res.data.test), [athleteId]);
    const link = <ActionLink to={testsPath}>Open tests</ActionLink>;

    let body;
    if (status === 'loading' && data === undefined) body = <CardLoading label={TITLE} />;
    else if (status === 'error') body = <CardError label={TITLE} status={error?.response?.status} onRetry={reload} />;
    else if (!data) body = <CardEmpty>No test recorded yet.</CardEmpty>;
    else {
        const fields = [
            ['Test', `Type ${String(data.type).replace('Type:', '')}`],
            [data.dateSource === 'recordedAt' ? 'Recorded date' : 'Test date', dateText(data.date)],
            ['Pool', data.poolSize ? `${data.poolSize} m pool` : '–'],
            ['CSS', speed(data.css)],
            ['MSS', speed(data.mss)]
        ];
        body = (
            <dl className={styles.facts}>
                {fields.map(([label, value]) => (
                    <div key={label}>
                        <dt>{label}</dt>
                        <dd>{value}</dd>
                    </div>
                ))}
            </dl>
        );
    }

    return (
        <Card id="lt" module="athlete-latest-test" title={TITLE} busy={status === 'loading'} right={link}>
            {body}
        </Card>
    );
};

export default LatestTestCard;
